import { useState, useEffect } from "react";
import PDF from "../../../modules/pdf/utility/PDF";
import {
  useFetchedDocumentSelector,
  useSplitPagesSelector,
} from "../../../store/documents/DocumentSelector";
import { useDispatch } from "react-redux";
import { documentsActions } from "../../../store/documents/DocumentReducer";
import { useToast } from "../../../components/toast";
import { useTranslation } from "react-i18next";
import { BlobCache } from "../utils/BlobCache";

export function usePdfPages() {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const fetchedDocumentData = useFetchedDocumentSelector();
  const splitPages = useSplitPagesSelector();
  const { danger } = useToast();
  const { t } = useTranslation();

  useEffect(() => {
    if (splitPages && splitPages?.length > 0) return;

    const blob = BlobCache.get();
    const convertToImages = async () => {
      if (!fetchedDocumentData?.files || !blob) return;

      try {
        setLoading(true);

        const file = new File([blob], fetchedDocumentData?.files?.[0]?.name, {
          type: "application/pdf",
        });

        const imagePages = await PDF.splitIntoImages(file);

        dispatch(documentsActions.setSplitPages(imagePages));
      } catch (err: any) {
        danger(t("ERRORS.CONVERT_TO_IMAGES"));
        setError(err.message || "Failed to convert PDF to images");
      } finally {
        setLoading(false);
      }
    };

    convertToImages();
  }, [splitPages]);

  return { loading, error };
}
